import React, { useEffect, useRef, useState } from 'react';
import { Container, RightContainer, Title, DescriptionInput, DescriptionText } from './styled.js';
import DescriptionIcon from '@mui/icons-material/TextSnippetOutlined';
import BottomButtonGroup from '../../../Pages/BoardPage/BoardComponents/BottomButtonGroup/BottomButtonGroup.js';
import { useDispatch, useSelector } from 'react-redux';
import { numeroSEIUpdateEntrega } from '../../../../Services/cardService.js';


const NumeroSEIEntrega = () => {

  const thisCard = useSelector((state) => state.card);
  
	const dispatch = useDispatch();
	const [inputFocus, setInputFocus] = useState(false);
	const [numSeiEntrega, setNumSeiEntrega] = useState(thisCard.numSeiEntrega);
	const ref = useRef();
	const ref2 = useRef();

	const handleSaveClick = async () => {
		setInputFocus(false);
		await numeroSEIUpdateEntrega(thisCard.cardId, thisCard.listId, thisCard.boardId, numSeiEntrega, dispatch);
	};

	useEffect(() => {
		setNumSeiEntrega(thisCard.numSeiEntrega);
	}, [thisCard.numSeiEntrega]);

	useEffect(() => {
		if (inputFocus) {
			ref.current.focus();
		}
	}, [inputFocus]);

	const handleClickOutside = (event) => {
		if (ref2.current && !ref2.current.contains(event.target)) {
			setInputFocus(false);
			setNumSeiEntrega(thisCard.numSeiEntrega);
		} else {
			setInputFocus(true);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});

	return (
		<Container ref={ref2}>
			<DescriptionIcon fontSize='small' />
			<RightContainer>
				<Title>SEI Entrega</Title>
				{numSeiEntrega && !inputFocus ? (
					<DescriptionText onClick={() => setInputFocus(true)}>{numSeiEntrega}</DescriptionText>
				) : (
					<DescriptionInput
						ref={ref}
						minHeight={inputFocus ? '5.5rem' : '2.5rem'}
						placeholder='Adicione Número SEI...'
						value={numSeiEntrega}
						onChange={(e) => setNumSeiEntrega(e.target.value)}
					/>
				)}
				<div style={{ display: inputFocus ? 'block' : 'none' }}>
					<BottomButtonGroup
						closeCallback={() => {
							setInputFocus(false);
							setNumSeiEntrega(thisCard.numSeiEntrega);
						}}
						clickCallback={handleSaveClick}
						title='Salvar'
					/>
				</div>
			</RightContainer>
		</Container>
	);
};

export default NumeroSEIEntrega;
